import { render, staticRenderFns } from "./Congrats.vue?vue&type=template&id=6026b0cd&scoped=true&"
import script from "./Congrats.vue?vue&type=script&lang=js&"
export * from "./Congrats.vue?vue&type=script&lang=js&"
import style0 from "./Congrats.vue?vue&type=style&index=0&id=6026b0cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026b0cd",
  null
  
)

export default component.exports